import { useCallback, useState } from 'react';
import { PolicyTemplate } from '../../../../../types/policies';

const useTemplateActionModal = () => {
    const [open, setOpen] = useState(false);
    const [template, setTemplate] = useState<PolicyTemplate | undefined>();

    const openModal = useCallback((template: PolicyTemplate) => {
        setOpen(true);
        setTemplate(template);
    }, []);

    const closeModal = useCallback(() => {
        setOpen(false);
    }, []);

    return {
        open,
        template,
        openModal,
        closeModal
    };
};

export const useDuplicateTemplateModal = () => {
    const { open, template, openModal, closeModal } = useTemplateActionModal();

    return {
        open,
        templateToDuplicate: template,
        openDuplicateTemplateModal: openModal,
        closeDuplicateTemplateModal: closeModal
    };
};

export const useDeleteTemplateModal = () => {
    const { open, template, openModal, closeModal } = useTemplateActionModal();

    return {
        open,
        templateToDelete: template,
        openDeleteTemplateModal: openModal,
        closeDeleteTemplateModal: closeModal
    };
};
